<script lang="ts">
    import { onMount } from "svelte"
    export let html: string
    export let components: {
        [code: string]: any
    }
    const ELEMENT_NODE = 1

    let fragment: HTMLElement

    function replaceComponents(node: HTMLElement) {
        if (node.nodeType == ELEMENT_NODE) {
            if (node.localName.startsWith("shortcode:")) {
                const props = {}
                for (let i = 0; i < node.attributes.length; i++) {
                    props[node.attributes[i].name] = node.attributes[i].value
                }
                props["slot"] = node.innerHTML
                node.innerHTML = ""

                const comp = components[node.localName.split(":")[1]]
                // TODO workaround, no idea why svelte is not working synchronous here
                window.setTimeout(() => {
                    new comp({
                        target: node,
                        props,
                    })
                    node.replaceWith(...node.childNodes)
                })
            } else {
                node.childNodes?.forEach((n: HTMLElement) => {
                    replaceComponents(n)
                })
            }
        }
    }

    onMount(() => {
        Object.keys(components).forEach((k) => {
            html = html
                .replace(
                    new RegExp("\\[(" + k + "[^\\]]*)\\]", "g"),
                    "<shortcode:$1>"
                )
                .replace(
                    new RegExp("\\[/" + k + "\\]", "g"),
                    "</shortcode:" + k + ">"
                )
        })
        fragment.innerHTML = html
        replaceComponents(fragment)
        // elimated fragment, so no update for preview
        fragment.replaceWith(...fragment.childNodes)
        //console.log(fragment)
    })
</script>

{#if typeof window === "undefined"}
    {@html html}
{:else}
    <fragment bind:this="{fragment}"></fragment>
{/if}
